export default __webpack_public_path__ + "static/media/mic-on.8131d83e.svg";